import { formatCount, formatMonthYear } from '@/domain/warehouse';
import type { WarehouseListFold } from '@/data/warehouse';

export type WarehouseNoun = { singular: string; plural: string };

/** "Showing 1–50 of 258 open transfers · 3,099 folded". Folded rows are never counted in the total. */
export function warehouseCountText(params: {
  loading: boolean;
  page: number;
  pageSize: number;
  total: number;
  noun: WarehouseNoun;
  /** The status filter is the default "Open" set. */
  openOnly: boolean;
  fold: WarehouseListFold | null | undefined;
}): string {
  const { loading, page, pageSize, total, noun, openOnly, fold } = params;
  if (loading) return `Loading ${noun.plural}…`;
  const last = Math.min(page * pageSize, total);
  const first = total > 0 ? Math.min((page - 1) * pageSize + 1, last) : 0;
  const folded = fold && fold.count > 0 && !fold.included ? ` · ${formatCount(fold.count)} folded` : '';
  return `Showing ${formatCount(first)}–${formatCount(last)} of ${formatCount(total)} ${openOnly ? 'open ' : ''}`
    + `${total === 1 ? noun.singular : noun.plural}${folded}`;
}

function sentence(parts: ReadonlyArray<string | null | undefined>): string | null {
  const text = parts.filter(Boolean).join('; ');
  return text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}.` : null;
}

/** "2,799 are over a year old; the oldest is from Dec 2014." or null when neither is known. */
export function foldAgeSentence(fold: WarehouseListFold): string | null {
  return sentence([
    fold.olderThanYear > 0 ? `${formatCount(fold.olderThanYear)} ${fold.olderThanYear === 1 ? 'is' : 'are'} over a year old` : null,
    fold.oldestDay ? `the oldest is from ${formatMonthYear(fold.oldestDay)}` : null,
  ]);
}

export const FOLD_TAIL = 'They stay out of the working list until you open them.';
